import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Loader2, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function BillingCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const reference = params.get('reference') || params.get('trxref');
  const [status, setStatus] = useState('verifying'); // verifying | success | failed
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!reference) {
      setStatus('failed');
      return;
    }
    axios.get(`${API}/subscription/verify/${reference}`, { withCredentials: true })
      .then(r => {
        setDetails(r.data);
        setStatus(r.data.verified ? 'success' : 'failed');
      })
      .catch(() => setStatus('failed'));
  }, [reference]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white/80 backdrop-blur-xl border border-[var(--border-glass)] rounded-3xl p-10 text-center shadow-xl">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-12 h-12 text-[var(--ocean-surface)] animate-spin mx-auto" />
            <h2 className="text-2xl font-bold text-[var(--ocean-deep)] mt-5" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Verifying your payment…</h2>
            <p className="text-sm text-[var(--text-secondary)] mt-2">Hang tight — this only takes a moment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[var(--ocean-surface)] to-[var(--ocean-deep)] flex items-center justify-center mx-auto"><CheckCircle2 className="w-8 h-8 text-white"/></div>
            <h2 className="text-2xl font-bold text-[var(--ocean-deep)] mt-5" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>You're all set!</h2>
            <p className="text-sm text-[var(--text-secondary)] mt-2">Your subscription is active. Welcome aboard.</p>
            <button onClick={() => navigate('/dashboard')} className="mt-6 w-full inline-flex items-center justify-center gap-2 px-5 py-3.5 rounded-xl bg-gradient-to-br from-[var(--ocean-surface)] to-[var(--ocean-deep)] text-white font-semibold">Go to dashboard <ArrowRight className="w-4 h-4"/></button>
          </>
        )}
        {status === 'failed' && (
          <>
            <div className="w-16 h-16 rounded-2xl bg-[var(--ocean-coral)]/15 flex items-center justify-center mx-auto"><XCircle className="w-8 h-8 text-[var(--ocean-coral)]"/></div>
            <h2 className="text-2xl font-bold text-[var(--ocean-deep)] mt-5" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Payment not completed</h2>
            <p className="text-sm text-[var(--text-secondary)] mt-2">No charge was made. You can try again or keep using your trial.</p>
            <div className="mt-6 flex flex-col gap-2">
              <Link to="/billing" className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-br from-[var(--ocean-surface)] to-[var(--ocean-deep)] text-white font-semibold">Try again</Link>
              <Link to="/dashboard" className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-white border border-[var(--border-glass)] text-[var(--ocean-deep)] font-semibold">Back to dashboard</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
